import clsx from "clsx";

import type { TagCloudStoryblok } from "@/types/blok-types";

import StoryblokComponent from "@/lib/storyblok/storyblokSetup/StoryblokComponent/StoryblokComponent";
import styles from "./tag-cloud.module.css";

const TagCloud = ({
  blok,
  preview
}: {
  blok: TagCloudStoryblok;
  preview: boolean;
}) => {
  return (
    <div data-layout="blok" data-container="small" className={styles.wrapper}>
      <div className={clsx(styles.root)}>
        {blok.tags.map((tag) => (
          <StoryblokComponent key={tag._uid} blok={tag} preview={preview} />
        ))}
      </div>
      <div className={styles["image-placeholder"]} />
    </div>
  );
};

export default TagCloud;
